const s = {
  name: "EventCode",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,5c0-2.8,2.2-5,5-5h1v2H9C7.3,2,6,3.3,6,5v7c0,1.6-0.8,3.1-2,4c1.2,0.9,2,2.4,2,4v7c0,1.7,1.3,3,3,3h1v2H9
			c-2.8,0-5-2.2-5-5v-7c0-1.7-1.3-3-3-3H0v-2h1c1.7,0,3-1.3,3-3V5z"/>
		<path class="st0" d="M36,20c0-1.7,1.3-3,3-3h1v-2h-1c-1.7,0-3-1.3-3-3V5c0-2.8-2.2-5-5-5h-1v2h1c1.7,0,3,1.3,3,3v7
			c0,1.6,0.8,3.1,2,4c-1.2,0.9-2,2.4-2,4v7c0,1.7-1.3,3-3,3h-1v2h1c2.8,0,5-2.2,5-5V20z"/>
		<path class="st0" d="M9,7h22V5H9V7z"/>
		<path class="st0" d="M31,27H9v-2h22V27z"/>
		<path class="st0" d="M18,17h4v-2h-4V17z"/>
		<path class="st0" d="M31,17h-6v-2h6V17z"/>
		<path class="st0" d="M15,17v-2H9v2H15z"/>
		<path class="st0" d="M31,12H15v-2h16V12z"/>
		<path class="st0" d="M9,22h16v-2H9V22z"/>
		<path class="st0" d="M12,12H9v-2h3V12z"/>
		<path class="st0" d="M28,22h3v-2h-3V22z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as EventCode
};
